// Shared helpers for Mobile Operations Mode (additive module — desktop untouched).
export const mt = {
  bg: "#070f1f", panel: "#0d1a30", surface: "#122642", border: "#1d3252",
  text: "#E7EEF9", dim: "#8299bd", blue: "#2563EB", green: "#16A34A",
  amber: "#D9A441", red: "#DC2626", cyan: "#0EA5E9", purple: "#8B5CF6",
};

export const SEV_COLOR = {
  emergency: "#DC2626", critical: "#EA580C", urgent: "#D9A441",
  warning: "#EAB308", info: "#0EA5E9", admin: "#8299bd",
};

export function deviceId() {
  let id = localStorage.getItem("mob_device_id");
  if (!id) {
    id = "mob-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("mob_device_id", id);
  }
  return id;
}

export function getGps() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve({ lat: null, lng: null });
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: +p.coords.latitude.toFixed(6), lng: +p.coords.longitude.toFixed(6) }),
      () => resolve({ lat: null, lng: null }),
      { enableHighAccuracy: true, timeout: 5000, maximumAge: 30000 });
  });
}

export function vibrate(pattern = [80, 40, 80]) {
  try { navigator.vibrate && navigator.vibrate(pattern); } catch { /* noop */ }
}

export const fmtT = (ts) => {
  try {
    return new Date(ts).toLocaleString("en-US", {
      month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit",
      hour12: false, timeZone: "America/New_York" });
  } catch { return String(ts || "").slice(0, 16); }
};

export const elapsedMin = (ts) => {
  try { return Math.max(0, Math.floor((Date.now() - new Date(ts).getTime()) / 60000)); } catch { return 0; }
};

// Big touch-friendly button (one-handed / gloved use).
export function MBtn({ children, onClick, color = mt.blue, outline = false, full = false, testid, disabled, small = false }) {
  return (
    <button data-testid={testid} onClick={onClick} disabled={disabled}
      className={`font-head font-bold rounded-lg transition-colors active:scale-95 ${small ? "px-3 py-2 text-xs" : "px-4 py-3.5 text-sm"} ${full ? "w-full" : ""}`}
      style={outline
        ? { background: "transparent", color, border: `1.5px solid ${color}`, opacity: disabled ? 0.4 : 1 }
        : { background: color, color: "#fff", opacity: disabled ? 0.4 : 1 }}>
      {children}
    </button>
  );
}

export function MCard({ children, testid, style = {} }) {
  return (
    <div data-testid={testid} className="rounded-xl p-4"
      style={{ background: mt.panel, border: `1px solid ${mt.border}`, ...style }}>
      {children}
    </div>
  );
}
